export default import.meta.ROLLDOWN_FILE_URL_$Pi3XVCGJe3hhcJFpC8Yrg